export const normalizeRole = (raw) => {
  if (!raw) return null;
  const s = String(raw).trim().toLowerCase();
  if (["superadmin", "super-admin", "admin"].includes(s)) return "superadmin";
  if (["donor", "donante"].includes(s)) return "donor";
  if (["requester", "solicitante", "user", "usuario"].includes(s)) return "requester";
  return s;
};

export const isSuperadminRole = (role) => normalizeRole(role) === "superadmin";
export const isDonorRole = (role) => normalizeRole(role) === "donor";
export const isRequesterRole = (role) => normalizeRole(role) === "requester";
